const PENDING_AUTH_RETURN_PATH_KEY = "austuition.auth.return_path";

function normalizeInternalPath(value) {
  const text = String(value || "").trim();
  return text.startsWith("/") ? text : "";
}

export function rememberReturnPath(value) {
  const path = normalizeInternalPath(value);
  if (!path) return "";
  try {
    window.sessionStorage.setItem(PENDING_AUTH_RETURN_PATH_KEY, path);
  } catch {
    // Ignore storage errors and let route state carry the fallback path.
  }
  return path;
}

export function readRememberedReturnPath() {
  try {
    return normalizeInternalPath(window.sessionStorage.getItem(PENDING_AUTH_RETURN_PATH_KEY));
  } catch {
    return "";
  }
}

export function consumeReturnPath() {
  const path = readRememberedReturnPath();
  try {
    window.sessionStorage.removeItem(PENDING_AUTH_RETURN_PATH_KEY);
  } catch {
    // Ignore storage errors.
  }
  return path;
}

export function resolveReturnPath(...candidates) {
  for (const value of candidates) {
    const path = normalizeInternalPath(value);
    if (path) return path;
  }
  return "";
}
